(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('AgenceTemplate', AgenceTemplate);

    AgenceTemplate.$inject = ['$resource'];

    function AgenceTemplate($resource) {
        return $resource('api/agences/:idArea/template-conf', {}, {
            'validateHtml': {
                url: 'api/template-html/validate',
                method: 'POST'
            },
            'validateDocumentTemplate': {
                url: 'api/template-html/validate-document',
                method: 'POST'
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    if (data) {
                        return angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function(data) {
                    return angular.toJson(angular.copy(data));
                }
            }
        });
    }
})();
